"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileButtonOrganizer = exports.MobileLink = exports.MobileButton = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const reactstrap_1 = require("reactstrap");
const CommonMobileButtonCss = (0, styled_components_1.css) `
        text-shadow: none;
    }
`;
const CommonMobileButtonSegundoCss = (0, styled_components_1.css) `
        text-shadow: none;
    }
`;
exports.MobileButton = (0, styled_components_1.default)(reactstrap_1.Button) `
    
`;
exports.MobileLink = styled_components_1.default.a `
    
`;
exports.MobileButtonOrganizer = styled_components_1.default.div `
    /*
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: flex-start;
    row-gap: 16px;
    column-gap: 8px;
    position: fixed;
    bottom: 0px;
    background-color: rgba(var(--branco), 1);
    padding: 16px 8px;
    border-top: 1px solid rgba(var(--cor-tema), .3);
    box-shadow: 0 0px 16px 0px rgba(var(--cor-tema), .3);
    width: 100%;
    z-index:1;
    */
    ${exports.MobileButton}{
        /*flex: 1 1 calc(50% - 10px);*/
        /*box-sizing: border-box;*/
    }

    @media (max-width: 500px) {
        /*flex: 1 1 100%;*/
    }
`;
